import "./styles.scss";

interface TableFilterTitleProps {
  title: string | React.ReactNode;
  sortable?: boolean;
  icon?: React.ReactNode;
  onClick?: (event: unknown) => void;
}

export const TableFilterTitle = ({
  title,
  sortable,
  icon,
  onClick,
}: TableFilterTitleProps) => {
  return (
    <div
      className="table-filter-title-wrapper d-flex justify-content-center align-items-center gap-1"
      onClick={onClick}
    >
      <div className="small-font-size filter-title-text">{title}</div>
      {sortable && icon && (
        <div className="filter-title-icon-wrapper d-flex justify-content-center align-items-center">
          {icon}
        </div>
      )}
    </div>
  );
};
